import type { ModelLinkProps, OnModelLinkClick } from "./model-link.type";

import { ExportOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import ModelIcon from "@/modules/model-icon";
import { useOrganizationCustomContextNotify } from "@/modules/organization/organization-context";
import PageModalLink from "@/modules/page-modal-link";

import { useModelLinkInline } from "./model-link.hook";

import "./model-link.style.less";

export const ModelLink = ({
  ref,
  model,
  item,
  customContext,
  customModel,
  modelAsName,
  showIcon,
  inModal,
  modalState,
  search,
  target,
  title,
  "aria-label": ariaLabel,
  onClick,
  children,
}: ModelLinkProps) => {
  const { t } = useTranslation();
  const { notifyContextChange } = useOrganizationCustomContextNotify();

  const linkOptions = { context: customContext, id: item?.id, search };
  const link = useModelLinkInline(model, linkOptions);

  const LinkComponent = inModal ? PageModalLink : Link;
  const modalProps = inModal ? { modalState } : {};

  if (!link || !item) return undefined;

  const displayedModel = customModel ?? model;

  const onLinkClick: OnModelLinkClick = (e) => {
    notifyContextChange(customContext);
    onClick?.(e);
  };

  return (
    <div ref={ref} className="model-link">
      {showIcon === true && <ModelIcon model={displayedModel} />}
      <LinkComponent
        {...modalProps}
        to={link}
        target={target}
        title={title}
        onClick={onLinkClick}
        aria-label={ariaLabel}
      >
        {children ??
          (modelAsName ? t(`global:modelLink.${displayedModel}`) : item.name)}
      </LinkComponent>
      {showIcon === "external" && <ExportOutlined />}
    </div>
  );
};
